// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"6":"a31d2548","10":"d397567c","30":"0c6ff6e0"}[chunkId] + ".js";
};